<app-loading-spinner *ngIf="!((homePageData | keyvalue)?.length) else HomePage">
</app-loading-spinner>

<ng-template #HomePage>
<app-banner
  [image]="image"
  [bannerTitle]="bannerTitle"
  [bannerDescription]="bannerDescription"
  [additionalStyles]=""
></app-banner>
<app-banner-features [bannerFeatures]="homePageData.bannerFeaturesArray"></app-banner-features>
<!-- <app-asset-card></app-asset-card> -->
<!-- Newest Assets Section Starts -->
<section class="newest-asset-section">
  <div class="mid-layout">
      <div class="row">
          <div class="col-md-12 p-l">
              <div class="newAssetsTitle">Newest Assets</div>
          </div>
      </div>
      <div class="row padding-new-asset">
         <app-newest-asset-card [newestAssetArray]="homePageData.newestAssetArray"></app-newest-asset-card>
      </div>
      <div class="row">
          <div class="container">
              <div class="text-center">
                  <button class="uil-btn-bordered" (click)="seeMoreAssetsClicked()">View more assets</button>
              </div>
          </div>
      </div>

  </div>
</section>
<!-- Newest Assets Section ends -->
<!-- Explore More Section Starts -->
<section class="explore_more container-fluid">
  <div class="mid-layout">
    <div class="row">
      <div class="col-md-12 p-l">
        <div class="quickTitle">Explore More</div>
        <div class="subHeading">
          Learn more about the functionality and features of the developer hub or reach out to us for support.
        </div>
      </div>
        <app-link-card [LinkCardArr]="homePageData.ExploreMoreArr"></app-link-card>
    </div>
  </div>
</section>

<section class="contact">
      <div class="mid-layout">
        <div class="row">
          <div class="col-md-12 p-l">
            <p class="contacts-title">Contacts</p>
            <app-contact-card [contactData]="homePageData.contactArray"></app-contact-card>
          </div>
        </div>
      </div>
</section>
</ng-template>


<basic-dialog *ngIf="showDisclaimerPopup" [visible]="showDisclaimerPopup" [modalId]="DISCLAIMER_POPUP"
  [modalStyles]="{ 'min-width': '550px', width: '655px', right: '-10px' }" [dialogStyles]="{ height: '100%' }">
  <div class="modal-header">
    <h5 class="modal-title">Confidential Information – Reminder</h5>
  
  </div>
  <div class="modal-body">
    <br/>
    <br/>
    <div class="terms-condition">
      <p style="line-height: 1.67;">
        You are about to access the Industry X Developer Hub module.
          You understand that this tool is for INTERNAL USE ONLY and may contain Accenture, client or vendor/partner sensitive or confidential information.
           The tool provides access to curated content from internal and approved external sources. For usage restrictions, refer to the asset restriction type and follow the source guidelines. 
          More information can be found at: <a class="termsLink" href="https://in.accenture.com/protectingaccenture/5422-2/" target="_blank">Global Privacy Statement</a>, <a class="termsLink" href="https://policies.accenture.com/Pages/0001-0100/0069.aspx" target="_blank">Policy 69 - Confidentiality</a>, <a class="termsLink" href="https://policies.accenture.com/Pages/0001-0100/0057.aspx" target="_blank">Policy 57 - Security of information and Acceptable Use of System</a> and <a class="termsLink" href="https://policies.accenture.com/Pages/0001-0100/0051.aspx" target="_blank">Policy 51 - Use and Distribution of Packaged Knowledge.</a>
      </p>
    </div>

  </div>
  <div class="modal-footer">
    <div class="row">
      
        <button type="button" class="btn btn-primary agree-btn" data-dismiss="modal" (click)="closepopup()"
          style="cursor: pointer">
          I Understand
        </button>
      
    </div>
  </div>
</basic-dialog>